export default __webpack_public_path__ + "static/media/long_active.d0e619ea.svg";